<template>
  <div>
    <el-table :data="list"
              ref="durationTable"
              border
              stripe
              size="mini"
              height="calc(100vh - 115px)"
              v-loading="loading">
      <el-table-column type="index"
                       label="序号"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column prop="assetTypeName"
                       label="设备类型">
      </el-table-column>
      <el-table-column prop="levelName"
                       label="故障等级">
      </el-table-column>
      <el-table-column label="故障时长（小时）"
                       width="300"
                       prop="duration">
        <template slot-scope="scope">
          <template v-if="!scope.row.edit">
            <span>{{scope.row.duration}}</span>
            <el-link :underline="false"
                     title="编辑"
                     @click="scope.row.edit=true"
                     size="mini"
                     style="margin-left:8px;font-size:10px"
                     type="primary"><i class="el-icon-edit"></i></el-link>
          </template>
          <template v-else>
            <el-input-number size="mini"
                             v-model="scope.row.duration"></el-input-number>
            <el-link :underline="false"
                     title="保存"
                     @click="submit(scope.row)"
                     size="mini"
                     style="margin-left:8px;font-size:12px"
                     type="primary"><i class="el-icon-check"></i></el-link>
            <el-link :underline="false"
                     title="取消"
                     @click="scope.row.edit=false"
                     size="mini"
                     style="margin-left:8px;font-size:12px"
                     type="danger"><i class="el-icon-close"></i></el-link>
          </template>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
export default {
  name: 'fauduration',
  props: ["funcs"],
  data () {
    return {
      list: [],
      assetTypes: [],
      levels: [],
      loading: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadTypeListAll()
    },

    //初始化设备类型下拉框
    loadTypeListAll () {
      this.loading = true
      this.$ajax.get('/base/assettype/list_all').then((msg) => {
        this.assetTypes = msg
        //同步
        this.loadFauLevelListAll()
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    //初始化故障等级下拉框
    loadFauLevelListAll () {
      this.$ajax.get('/base/faultlevel/list_all', {
      }).then((msg) => {
        this.levels = msg
        //同步
        this.loadDurationList()
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    //从后台查询故障时长
    loadDurationList () {
      this.list = []
      this.$ajax.get('/buss/fauduration/list').then((msg) => {
        this.assetTypes.forEach(item => {
          let o = new Object()
          this.$set(o, 'assetTypeId', item.id)
          this.$set(o, 'assetTypeName', item.name)
          this.levels.forEach(e => {
            this.$set(o, 'levelId', e.id)
            this.$set(o, 'levelName', e.name)
            this.$set(o, 'duration', 4)
            this.$set(o, 'edit', false)
            for (let i = 0; i < msg.length; i++) {
              if (msg[i].assetTypeId == item.id && msg[i].levelId == e.id) {
                this.$set(o, 'id', msg[i].id)
                this.$set(o, 'duration', msg[i].duration)
                break
              }
            }
            this.list.push(JSON.parse(JSON.stringify(o)))
          })
        })
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    // 保存故障时长
    submit (row) {
      console.log(row)
      let url = "/buss/fauduration/add";
      if (row.id != null) {
        url = "/buss/fauduration/edit";
      }
      this.$ajax.post(url, row).then(msg => {
        row.edit = false
        this.$message.success(msg)
      }).catch(err => {
        this.$message.error(err)
      })
    },

  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
